import { render, staticRenderFns } from "./TrafficTrends.vue?vue&type=template&id=382271bc"
import script from "./TrafficTrends.vue?vue&type=script&lang=js"
export * from "./TrafficTrends.vue?vue&type=script&lang=js"
import style0 from "./TrafficTrends.vue?vue&type=style&index=0&id=382271bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports